import {
    GetOrders,
    GetCarts,
    GetWishlist,
    CreateManualOrder,
    UpdateOrderStatus,
    MarkOrderPaid,
    GetOrderAddresses,
    UpdateOrderAddresses,
} from "@/services/ecommerce";

export const getEcomOrders = (context, params) => {
    context.commit("updateLoader", { getEcomOrders: true });
    return new Promise((resolve, reject) => {
        GetOrders(params)
            .then(res => {
                context.commit("setEcomOrders", res.data.data);
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { getEcomOrders: false }));
    });
};

export const createManualOrder = (context, data) => {
    context.commit("updateLoader", { createManualOrder: true });
    return new Promise((resolve, reject) => {
        CreateManualOrder(data)
            .then(res => {
                context.commit("addEcomOrder", res.data.data);
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { createManualOrder: false }));
    });
};

export const updateOrderStatus = (context, { id, status }) => {
    context.commit("updateLoader", { updateOrderStatus: true });
    return new Promise((resolve, reject) => {
        UpdateOrderStatus(id, status)
            .then(res => {
                context.commit("updateEcomOrder", res.data.data);
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { updateOrderStatus: false }));
    });
};

export const markOrderPaid = (context, id) => {
    context.commit("updateLoader", { markOrderPaid: true });
    return new Promise((resolve, reject) => {
        MarkOrderPaid(id)
            .then(res => {
                context.commit("updateEcomOrder", res.data.data);
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { markOrderPaid: false }));
    });
};

export const getOrderAddresses = (context, id) => {
    context.commit("updateLoader", { getOrderAddresses: true });
    return new Promise((resolve, reject) => {
        GetOrderAddresses(id)
            .then(res => {
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { getOrderAddresses: false }));
    });
};

export const updateOrderAddresses = (context, { id, ...data }) => {
    context.commit("updateLoader", { updateOrderAddresses: true });
    return new Promise((resolve, reject) => {
        UpdateOrderAddresses(id, data)
            .then(res => {
                context.commit("updateEcomOrder", res.data.data);
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { updateOrderAddresses: false }));
    });
};

export const getEcomCarts = (context, params) => {
    context.commit("updateLoader", { getEcomCarts: true });
    return new Promise((resolve, reject) => {
        GetCarts(params)
            .then(res => {
                context.commit("setEcomCarts", res.data.data);
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { getEcomCarts: false }));
    });
};

export const getWishlistItems = (context, params) => {
    context.commit("updateLoader", { getWishlistItems: true });
    return new Promise((resolve, reject) => {
        GetWishlist(params)
            .then(res => {
                context.commit("setWishlistItems", res.data.data);
                resolve(res.data.data);
            })
            .catch(err => reject(err))
            .finally(() => context.commit("updateLoader", { getWishlistItems: false }));
    });
};

const EcommerceAction = {
    getEcomOrders,
    createManualOrder,
    updateOrderStatus,
    markOrderPaid,
    getOrderAddresses,
    updateOrderAddresses,
    getEcomCarts,
    getWishlistItems,
};

export default EcommerceAction;
